module.exports = __webpack_public_path__ + "static/media/acto_de_grado_6.c31544c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/acto_de_grado_6.jpg
// module id = 913
// module chunks = 0